import React, { FC } from 'react';

import ContentArea from 'components/common/ContentArea';

import useStyles from './style';

const BeatsourcePlayBarPlaceholder: FC = () => {
  const classes = useStyles();

  return (
    <ContentArea className={classes.beatsourcePlayBarPlaceholder} shadowed>
      <span />
    </ContentArea>
  );
};

export default BeatsourcePlayBarPlaceholder;
